<div class="tables-layout__canvas-view-container" id="canvaContainer">
  <div class="tables-layout__canvas-view" #canvasLoader >
    <!-- <ng-scrollbar [trackX]="true">   -->
    <canvas id="tablesLayout" #tablesLayout></canvas>
    <!-- </ng-scrollbar> -->

  </div>

  <div class="location-detail" *ngIf="locationDetail" [ngStyle]="locationDetail.position">
    <div class="location-detail__header-label" [class]="locationDetail.availability">
      {{locationDetail.availability | translate}}
    </div>
    <div class="location-detail__location-name">
      {{locationDetail.Name}}
    </div>
    <div class="location-detail__location-name" *ngIf="locationDetail.Price">
      {{  'Price' | translate }}: {{ guestService.selectedNonDining.OperationCurrency }} {{locationDetail.Price | currencyDecimalFormatter}}
    </div>
    <div class="location-detail__party" *ngIf="guestService.validateLocationSize">
      {{locationDetail.MinPartySize}} {{'Min' | translate}} &nbsp; | &nbsp; {{locationDetail.MaxPartySize}} {{'Max' |
      translate}}
    </div>
  </div>
</div>